export default __webpack_public_path__ + "static/media/nave.461d44c6.png";